import { canUseAnalytics, canUseMarketing, getOrCreateAnonymousId } from "@/components/cookies/consentManager";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

function getEndpointUrl() {
  if (!SUPABASE_URL) return "";
  return `${SUPABASE_URL.replace(/\/$/, "")}/functions/v1/trackEvent`;
}

/**
 * First‑party internal tracking:
 * - We always allow sending events to our own backend (Supabase Edge Function)
 * - We avoid touching browser storage when consent isn't granted
 *   (ETP / Private windows often block 3p storage and sometimes even persistence).
 */
function canUseStorageForAnonId() {
  return canUseAnalytics() || canUseMarketing();
}

function ephemeralAnonId() {
  // No storage; per-page anonymous id
  try {
    return typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `anon_${Math.random().toString(16).slice(2)}`;
  } catch {
    return `anon_${Math.random().toString(16).slice(2)}`;
  }
}

export async function trackEvent({
  eventName,
  page,
  source = "web",
  userId = null,
  customData = null,
} = {}) {
  try {
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return false;

    const url = getEndpointUrl();
    if (!url) return false;

    const payload = {
      event_name: String(eventName || "").trim(),
      page: page || (typeof window !== "undefined" ? window.location.href : ""),
      source,
      anonymous_id: canUseStorageForAnonId() ? getOrCreateAnonymousId() : ephemeralAnonId(),
      user_id: userId,
      custom_data: customData,
      ts: Date.now(),
    };

    if (!payload.event_name) return false;

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });

    return true;
  } catch (_) {
    return false;
  }
}
